<template>
  <div class="wrapper">
    <!--视频-->
    <video-player id="video" class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="playsinline"
      :options="playerOptions"
      @canplay="onPlayerCanplay($event)"
    ></video-player>
    <div class="tagHeader">
      <div
        :class="value.value==0?'tagItem disabled':active==index?'tagItem active':'tagItem'"
        v-for="(value, key, index) in obj"
        :key="index"
        @click="changeTags(index,value.value)"
      >
        <span>{{value.key}} {{value.value}}</span>
      </div>
    </div>
    <div id="scroll">
      <van-list :finished-text="comment.length?'没有更多了':''" class="listWrap" v-model="loading" :finished="finished" @load="getData" :offset="20">
      <div class="listItem" v-for="(item,index) in comment" :key="`${item.user_nbr + '' + index}`">
        <div class="avatar">
          <img class="headPic" :src="item.head_pic" alt />
          <span class="name">{{item.nick_name}}</span>
          <div class="star">
            <img
              src="../../assets/images/feedback/star.png"
              v-for="key in new Array(Number(item.comment_score))"
              :key="key"
            />
          </div>
        </div>
        <div class="property">
          <span>{{item.create_time.slice(0,10)}}</span>
          <span class="text">{{item.property_complete}}</span>
        </div>
        <div class="content" v-if="item.content">{{item.content}}</div>
        <div class="content" v-else>此用户未填写评价</div>
        <div class="imgArr" v-if="item.images||item.comment_video">
          <div v-if="item.comment_video" class="img" @click="playVideo(item.comment_video, index)">
            <img :src="item.comment_video_cover + `${imgCrop}resize,w_200`" alt  />
              <div v-if="playIndex==index" class="loading">
                <van-loading class="loadingIcon" type="spinner" color="#fff" />
              </div>
              <div v-else class="player">
                <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="">
              </div>
          </div>
          <div v-for="(img, index1) in item.images" class="img" @click="showImageArr(item.images,index1)">
            <img
              :src="img + `${imgCrop}resize,w_200`"
              :key="index1"
            />
          </div>
        </div>
      </div>
    </van-list>
    </div>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      playerOptions:{
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        sources: [],
        controlBar: {
          //timeDivider: true,
          //durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      playIndex:-1,
      obj: {
        totalRows: {
          key: "全部",
          value: "0"
        },
        good: {
          key: "好评",
          value: "0"
        },
        middle: {
          key: "中评",
          value: "0"
        },
        bad: {
          key: "差评",
          value: "0"
        },
        hasPic: {
          key: "有图",
          value: "0"
        }
      },
      pageIndex: 0,
      numPerPage: 10,
      loading: false, //上拉加载
      finished: false, //加载完成
      comment: [],
      active: 0
    };
  },
  watch: {},
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    playsinline(){
    	var ua = navigator.userAgent.toLocaleLowerCase();
       //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false
      }else{
        //ios端
      return true
      }
    },
  },
  methods: {
    full(element){
      //做兼容处理
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        var docHtml = document.documentElement;
        var docBody = document.body;
        var videobox = document.getElementsByClassName("video-player");
        var cssText = "width:100%;height:100%;overflow:hidden;";
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
        document.IsFullScreen = true;
      }
    },
    onPlayerCanplay(){
      this.playIndex = -1
      this.full(this.player)
    },
    playVideo(url,index){
      if(this.playIndex == index) return false;
      this.playIndex = index
      this.playerOptions.sources=[{
        type: "video/mp4",
        src:url
      }]
      setTimeout(()=>{
        this.player.play()
      },500)
    },
    showImage(img) {
      wx.previewImage({
        current: img,
        urls: [img]
      });
    },
    showImageArr(img, index){
     wx.previewImage({
       current:img[index],
       urls:img
     })
    },
    changeTags(index, num) {
      if(num == 0){
        return this.$toast({
            message: '暂无评价',
            duration: 2000
          });
      }
      this.comment = [];
      this.active = index;
      this.pageIndex = 0;
      this.finished = false;
      this.getData();
    },
    getData() {
      let that = this;
      this.loading = true;
      that
        .$commonPost({
          jydm: "flow_70072",
          flow_70072: {
            nbr: this.$route.query.nbr,
            page_index: this.pageIndex * this.numPerPage,
            num_per_page: this.numPerPage,
            type: this.active - 1
          }
        })
        .then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if (response.comment) {
              if (response.comment.length > 1) {
                arr = response.comment;
              } else {
                arr.push(response.comment);
              }
              arr.map(item => {
                if (item.comment_image) {
                  item.images = item.comment_image.split(",");
                }
              });
            }
          }
          this.loading = false;
          this.obj.totalRows.value = response.all_rows;
          this.obj.good.value = response.good_rows;
          this.obj.middle.value = response.middle_rows;
          this.obj.bad.value = response.bad_rows;
          this.obj.hasPic.value = response.image_rows;
          this.comment = this.comment.concat(arr);
          this.pageIndex += 1;
          if (response.total_rows == this.comment.length) {
            this.finished = true;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    checkOption(){
      if(!(this.userInfo&&this.userInfo.nbr)){
        let option = {
          title: '我的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin,
          images: this.cdnImgPath + '/images/default/wx_head_default.jpg',
        }
        this.weChatShare(option);
      }else{
        let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
        };
        this.weChatShare(option);
      }
    },
  },
  created() {
    this.checkOption();
  },
  mounted() {
    document.title = "评价详情";
  }
};
</script>
<style scoped lang='stylus'></style>

<style scoped lang='less'>
#video{
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  left: -50%;
}
.wrapper {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
}
.tagHeader {
  min-width: 100%;
  box-sizing: border-box;
  height: 1.02rem;
  padding: 0.28rem 0.24rem;
  padding-bottom: 0.24rem;
  background: #fff;
  overflow: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
  .tagItem {
    padding: 0 0.2rem;
    height: 0.5rem;
    display: inline-block;
    border: 1px solid #cccccc;
    border-radius: 0.29rem;
    box-sizing: border-box;
    margin-right: 0.24rem;
    line-height: 0.5rem;
    span {
      font-size: 0.24rem;
      color: #333;
      font-weight: 400;
    }
  }
  .tagItem.active {
    background: #fff5f5;
    border: 1px solid #E52B25;
    span {
      color: #E52B25;
    }
  }
  .tagItem.disabled {
    background: #fff;
    border: 1px solid #ccc;
    span {
      color: #ccc;
    }
  }
}
#scroll{
  height: calc(100vh - 1.02rem);
  width: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling:touch;
}
.listWrap {
}
.listItem {
  width: 100%;
  padding: 0 0.24rem;
  padding-bottom: 0.24rem;
  border-top: 0.2rem solid #f5f5f5;
  box-sizing: border-box;
  background: #fff;
  .avatar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 1rem;
    .headPic {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      margin-right: 0.2rem;
    }
    .name {
      font-size: 0.28rem;
      font-weight: 400;
      color: #333;
    }
    .star {
      margin-left: 0.12rem;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.02rem;
      }
    }
  }
  .property {
    width: 100%;
    display: flex;
    align-items: center;
    span {
      color: #999;
      font-size: 0.24rem;
      font-weight: 500;
      margin-right: .14rem;
    }
    .text{
      display: inline-block;
      white-space:nowrap;
      overflow:hidden;
      width:calc(100% - 3rem);
      text-overflow: ellipsis;
    }
  }
  .content {
    width: 100%;
    margin-top: 0.3rem;
    font-size: 0.28rem;
    color: #333;
    font-weight: 500;
    line-height: 0.4rem;
    word-break:break-all;
  }
  .imgArr {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.14rem;
    flex-wrap: wrap;
    .img {
      width: 1.68rem;
      height: 1.68rem;
      object-fit:cover;
      margin-right: 0.12rem;
      border-radius: 0.04rem;
      margin-bottom: 0.1rem;
      position: relative;
      img{
        width: 1.68rem;
        height: 1.68rem;
        object-fit: cover;
      }
      .player{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: .8rem;
        height: .8rem;
        box-sizing: border-box;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #E8E8E8;
        background-color: rgba(0,0,0,0.5);
        .playIcon{
          width:.3rem !important;
          height:.3rem !important;
          margin-left: .07rem;
        }
      }
      .loading{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.1);
        .loadingIcon{
          width: .3rem;
          height: .3rem;
        }
      }
    }
    .img:nth-of-type(4n){
      margin:0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/feedback.vue